// import React, { useEffect, useState } from "react";
// import Layout, { Container } from "../components/layout";
// import { useUser } from "../config/userProvider";
// import axios from "axios";
// import { apiurl } from "../config/config";
// import { DynamicLoader } from "../components/loader";
// import { getCookie } from "../config/webStorage";
// import { useNavigate } from "react-router-dom";

// const Demos = () => {
//   let navigate = useNavigate();
//   const [loader, setLoader] = useState(false);
//   const [demoData, setDemoData] = useState([]);
//   let { userData } = useUser();
//   let token = getCookie("sctoken");

//   useEffect(() => {
//     setLoader(true);
//     let config = {
//       method: "get",
//       maxBodyLength: Infinity,
//       url: `${apiurl}/admin/v1/demo/get`,
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: token,
//       },
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         if (response.data.success === true) {
//           setDemoData(response.data.data);
//         }
//         setLoader(false);
//       })
//       .catch((error) => {
//         console.log(error);
//         setLoader(false);
//       });
//   }, []);

//   const goDemoDetails = (id) => {
//     navigate(`/demos/${id}`);
//   };
//   const events = [
//     {
//       date: "TODAY",
//       time: "17:00",
//       title: "Bergen International Film Festival",
//       description:
//         "Films from all over the world gather all film enthusiasts for unique moments at the Bergen International Film Festival.",
//       buttonStyle: "text-gray-500",
//     },
//     {
//       date: "22 - 31 OCT",
//       time: "10:00",
//       title: "Wool week",
//       description:
//         "ULLVEKA 2021 will be held for the eighth time in the period 22 - 31 October 2021, and will take place in the entire Bergen region.",
//       buttonStyle: "text-white bg-black",
//     },
//     {
//       date: "22 - 31 OCT",
//       time: "19:00",
//       title: "Light park at Bergenhus Fortress",
//       description:
//         "LUMAGICA - a magical experience for young and old at Bergenhus Fortress, 12 November to 19 December 2021.",
//       buttonStyle: "text-gray-500",
//     },
//     {
//       date: "13 - 31 DEC",
//       time: "10:00",
//       title: "Gingerbread City 2021",
//       description:
//         "The world's largest Gingerbread Town can be found in the Xhibition shopping center, right in the center of Bergen.",
//       buttonStyle: "text-gray-500",
//     },
//   ];
//   return (
//     <Layout>
//       <Container overflow={'overflow-scroll'}>
//         <div className="bg-gray-100 p-6 rounded-lg shadow-md mt-6">
//           {/* <h2 className="text-lg font-bold">Vendor Details</h2> */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mt-4">
//             <div className="text-center">
//               <h3 className="text-sm text-gray-600">Pending</h3>
//               <p className="font-bold text-yellow-600 text-2xl">00</p>
//               {/* <p className="text-gray-500">5,321</p> */}
//             </div>
//             <div className="text-center">
//               <h3 className="text-sm text-gray-600">Success</h3>
//               <p className="font-bold text-green-600 text-2xl">00</p>

//               {/* <p className="text-gray-500">2,679</p> */}
//             </div>
//             <div className="text-center">
//               <h3 className="text-sm text-gray-600">Today</h3>
//               <p className="font-bold text-blue-600 text-2xl">00</p>
//               {/* <p className="text-gray-500">1,216</p> */}
//             </div>
//             <div className="text-center">
//               <h3 className="text-sm text-gray-600">All</h3>
//               <p className="font-bold text-red-600 text-2xl">00</p>
//               {/* <p className="text-gray-500">1,216</p> */}
//             </div>
//           </div>
//         </div>

//         <div className="bg-gray-50 py-10 px-6">
//           <h2 className="text-2xl font-bold mb-6">Today Demos</h2>
//           <div className="space-y-4">
//             {events.map((event, index) => (
//               <div
//                 key={index}
//                 className="flex items-center justify-between bg-white p-4 shadow rounded-lg"
//               >
//                 <div className="flex items-center space-x-4">
//                   <div className="text-center">
//                     <p className="text-sm font-semibold text-gray-500">
//                       {event.date}
//                     </p>
//                     <p className="text-xl font-bold">{event.time}</p>
//                   </div>
//                   <div>
//                     <h3 className="text-lg font-bold">{event.title}</h3>
//                     <p className="text-sm text-gray-600">{event.description}</p>
//                   </div>
//                 </div>
//                 <button
//                   className={`px-4 py-2 rounded-lg border ${event.buttonStyle} hover:opacity-90`}
//                 >
//                   View
//                 </button>
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="p-6 min-h-screen">
//           <div className="mx-auto">
//             <div className="mt-8">
//               <div className="flex items-center justify-between mb-4">
//                 <h2 className="text-2xl font-semibold">All Demos</h2>
//                 <div className="flex gap-4">
//                   <input
//                     type="text"
//                     placeholder="Search by name"
//                     className="bg-white border border-gray-300 text-gray-700 py-2 px-4 rounded shadow-sm focus:outline-none"
//                   />
//                 </div>
//               </div>
//               <table className="w-full bg-white rounded-lg shadow">
//                 <thead>
//                   <tr className="bg-gray-100 capitalize">
//                     {[
//                       "SN",
//                       "Store Details",
//                       "Owner Details",
//                       "Email",
//                       "Phone Number",
//                       "Status",
//                     ].map((header, index) => (
//                       <th
//                         key={index}
//                         className={`${
//                           index === 0 || index === 1
//                             ? "text-left"
//                             : "text-center"
//                         } text-left py-3 px-4 text-gray-600 text-xs md:text-sm font-medium`}
//                       >
//                         {header}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {demoData && demoData.map((demo, index) => (
//                     <tr
//                       key={index}
//                       className="border-b last:border-b-0 hover:bg-gray-50 cursor-pointer"
//                       onClick={() => goDemoDetails(demo?._id)}
//                     >
//                       <td className="py-3 px-4">{index + 1}</td>
//                       <td className="py-3 px-4">
//                         <div className="flex items-center gap-2">
//                           <div>
//                             <p className="font-medium md:text-base text-sm capitalize">
//                               {demo?.firstName} {demo?.lastName}
//                             </p>
//                             <p className="md:text-sm text-xs text-gray-500">
//                               {demo?.id}
//                             </p>
//                           </div>
//                         </div>
//                       </td>
//                       <td className="py-3 px-4 text-center">
//                         <div>
//                           <p className="font-medium md:text-base text-sm capitalize">
//                             {demo?.companyName}
//                           </p>
//                           <p className="md:text-sm text-xs text-gray-500">
//                             {demo?.businessEmail}
//                           </p>
//                         </div>
//                       </td>
//                       <td className="py-3 px-4 text-center">
//                         {demo?.phone}
//                       </td>
//                       <td className="py-3 px-4 text-center">
//                         {demo?.product}
//                       </td>
//                       <td
//                         className={`py-3 px-4 text-center capitalize ${
//                           demo?.vendorDetails?.status === "enabled"
//                             ? "text-green-700"
//                             : "text-red-700"
//                         }`}
//                       >
//                         {demo?.vendorDetails?.status}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       </Container>
//     </Layout>
//   );
// };

// export default Demos;


import React, { useEffect, useState } from "react";
import Layout, { Container } from "../components/layout";
import axios from "axios";
import { apiurl } from "../config/config";
import { DynamicLoader } from "../components/loader";
import { getCookie } from "../config/webStorage";
import { useNavigate } from "react-router-dom";

const Demos = () => {
  let navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [demoData, setDemoData] = useState([]);
  const [filteredDemos, setFilteredDemos] = useState([]);
  const [todayDemos, setTodayDemos] = useState([]);
  const [productFilter, setProductFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  // let { userData } = useUser();
  let token = getCookie("sctoken");

  useEffect(() => {
    setLoader(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/demo/get`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.success) {
          const allDemos = response?.data?.data;
          setDemoData(allDemos);

          // Filter for today's demos
          const today = new Date().toISOString().split("T")[0]; // Current date in YYYY-MM-DD format
          console.log("today",today);
          // const todayDemos = response?.data?.data.filter((demo) =>
          //   demo.scheduleDate?.$date.startsWith(today)
          // );
          const todayDemos = response?.data?.data.filter((demo) => {
            console.log("scheduleDate", demo?.scheduleDate); // Debug each scheduleDate
            return demo?.scheduleDate?.startsWith(today);
          });
          setTodayDemos(todayDemos);
          console.log("todayDemos",todayDemos);

          // const filteredToday = allDemos.filter((demo) => demo?.scheduleDate === today);
          // setTodayDemos(filteredToday);
        }
        setLoader(false);
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  }, [token]);

  // Filter demos based on product and date
  useEffect(() => {
    let filtered = demoData;
    if (productFilter) {
      filtered = filtered.filter((demo) =>
        demo.product.toLowerCase().includes(productFilter.toLowerCase())
      );
    }
    if (dateFilter) {
      filtered = filtered.filter(
        (demo) => demo.scheduleDate === dateFilter
      );
    }
    setFilteredDemos(filtered);
  }, [productFilter, dateFilter, demoData]);

  const goDemoDetails = (id) => {
    navigate(`/demos/${id}`);
  };

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        {loader && <DynamicLoader />}
        <div className="bg-gray-100 p-6 rounded-lg shadow-md mt-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mt-4">
            <div className="text-center">
              <h3 className="text-sm text-gray-600">Pending</h3>
              <p className="font-bold text-yellow-600 text-2xl">
                {demoData.filter((demo) => demo.status === "Pending").length}
              </p>
            </div>
            <div className="text-center">
              <h3 className="text-sm text-gray-600">Success</h3>
              <p className="font-bold text-green-600 text-2xl">
                {demoData.filter((demo) => demo.status === "Success").length}
              </p>
            </div>
            <div className="text-center">
              <h3 className="text-sm text-gray-600">Today</h3>
              <p className="font-bold text-blue-600 text-2xl">
                {todayDemos.length}
              </p>
            </div>
            <div className="text-center">
              <h3 className="text-sm text-gray-600">All</h3>
              <p className="font-bold text-red-600 text-2xl">
                {demoData.length}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 py-10 px-6">
          <h2 className="text-2xl font-bold mb-6">Today's Demos</h2>
          <div className="space-y-4">
            {todayDemos.length > 0 ? (
              todayDemos.map((demo, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between bg-white p-4 shadow rounded-lg"
                >
                  <div className="flex items-center space-x-4">
                    <div>
                      <h3 className="text-lg font-bold">{demo.product}</h3>
                      <p className="text-sm text-gray-600">{demo.companyName}</p>
                    </div>
                  </div>
                  <button
                    className="px-4 py-2 rounded-lg border text-white bg-black hover:opacity-90"
                    onClick={() => goDemoDetails(demo._id)}
                  >
                    View
                  </button>
                </div>
              ))
            ) : (
              <p className="text-gray-500">No demos scheduled for today.</p>
            )}
          </div>
        </div>

        <div className="p-6">
          <div className="mx-auto">
            <div className="mt-8">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-2xl font-semibold">All Demos</h2>
                <div className="flex gap-4">
                  <input
                    type="text"
                    placeholder="Filter by product"
                    className="bg-white border border-gray-300 text-gray-700 py-2 px-4 rounded shadow-sm focus:outline-none"
                    onChange={(e) => setProductFilter(e.target.value)}
                  />
                  <input
                    type="date"
                    className="bg-white border border-gray-300 text-gray-700 py-2 px-4 rounded shadow-sm focus:outline-none"
                    onChange={(e) => setDateFilter(e.target.value)}
                  />
                </div>
              </div>
              <table className="w-full bg-white rounded-lg shadow">
                <thead>
                  <tr className="bg-gray-100 capitalize">
                    {["SN", "Product", "Company", "Date", "Actions"].map(
                      (header, index) => (
                        <th
                          key={index}
                          className="py-3 px-4 text-left text-gray-600 text-xs md:text-sm font-medium"
                        >
                          {header}
                        </th>
                      )
                    )}
                  </tr>
                </thead>
                <tbody>
                  {filteredDemos.map((demo, index) => (
                    <tr
                      key={index}
                      className="border-b last:border-b-0 hover:bg-gray-50 cursor-pointer"
                      onClick={() => goDemoDetails(demo._id)}
                    >
                      <td className="py-3 px-4">{index + 1}</td>
                      <td className="py-3 px-4">{demo.product}</td>
                      <td className="py-3 px-4">{demo.companyName}</td>
                      <td className="py-3 px-4">{demo.scheduleDate}</td>
                      <td className="py-3 px-4">
                        <button className="text-blue-500 hover:underline">
                          View Details
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {filteredDemos.length === 0 && (
                <p className="text-gray-500 text-center py-4">
                  No demos match the filters.
                </p>
              )}
            </div>
          </div>
        </div>
      </Container>
    </Layout>
  );
};

export default Demos;
